export const ROTATION = [
    'Veronika and Nataliia',
    'Svitlana and Ludmila',
    'Viktoriia and Nataliia',
];

export const ROTATION_START = new Date('2026-09-08');